// extracted by mini-css-extract-plugin
export default {"cls1":"PaperSelector-cls1_Kdq","cls2":"PaperSelector-cls2_VEl PaperSelector-cls1_Kdq","selected":"PaperSelector-selected_yuw"};